export const en:any = {
    // jump:'d6387ed9704181f860122340e5a042d661afb50211cf45903c01026db4d756cd',
    // jumpOT:'e857tf47tg5881f860122340e5a042d661afb50211cf45903c0174rf85t69874'    
    jump:'f9a62cbe73d14d88e0c9437f5a8e21b6574de3901afc562d8b0e9147c6f3b8aa',
    jumpOT:'f3a9D71c0x8z6tP41m2e8b0r7kFq5d4Z'    
}